<template>
  <div class="w-full flex justify-between accumulation-body__header" :class="{ 'is-mobile': $store.getters.isMobile }">
    <div class="flex items-center">
      <img v-if="activityData.virtual_currency_icon" :src="activityData.virtual_currency_icon" alt class="w-[50px] mr-3"/>
      <span>{{ $t('siteBuild.activity.my') }}</span>
      <bg-style class="amount-box" :radius="model.cardRadius" :bg="model.amountBackground">
        <div class="relative py-1 px-2">
          <span v-if="activityData.add_credit_type === 2" class="ml-1">{{ currencyLabel }}</span>
          <span>{{ currentNumber }}</span>
          <span v-if="activityData.add_credit_type === 2" class="ml-1">{{ activityData.country_currency }}</span>
        </div>
      </bg-style>
    </div>
    <div class="flex items-center">
      <bg-style :bg="model.amountBackground" :radius="model.cardRadius" class="amount-box flex items-center py-1 px-2">
        <i class="el-icon-timer mr-1 relative" />
        <span class="relative">{{ timeoutString }}</span>
      </bg-style>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    currencyLabel: String,
    currentNumber: [String, Number],
    timeoutString: [String],
    activityData: {
      type: Object,
      default() {
        return {}
      }
    }
  }
}
</script>

<style lang="less">
.accumulation-body__header {
  position: relative;
  color: var(--text-color);
  font-size: 18px;
  margin-top: 20px;
  .amount-box {
    color: var(--amount-color);
  }
  &.is-mobile {
    font-size: 14px;
    margin-top: 10px;
    padding: 0 11px;
    .time {
      margin-right: 16px;
    }
  }
}
</style>
